import React from 'react'

import {withStyles} from 'material-ui'
import classNames from 'classnames'

const styles = {
    root: {
        maxWidth: 800,
        margin: '0 auto',
        padding: 4,
    }
}

export const LandingBody = withStyles(styles)(
    ({classes, className='', children}) => (
        <section className={classNames(classes.root, className)}>
            {children}
        </section>
    )
)



// WEBPACK FOOTER //
// ./src/components/landinglib/LandingBody.jsx